import * as z from "zod";

export enum ProjectRole {
	Owner = 0,
	Admin = 1,
	Driver = 2,
}

export const projectRoleSchema = z.nativeEnum(ProjectRole);

export type UserDocumentData = z.infer<typeof userDocumentSchema>;

export const userDocumentSchema = z.object({
	FirstName: z.string().default(""),
	LastName: z.string().default(""),
});

export type ProjectDocumentData = z.infer<typeof projectDocumentSchema>;

export const projectDocumentSchema = z.object({
	Name: z.string().default(""),
	Members: z.record(projectRoleSchema).default({}),
	ArchivingDate: z.unknown().optional(),
	ArchiveOwner: z.string().optional(),
});

export type AddUserRequestData = z.infer<typeof addUserRequestSchema>;

export const addUserRequestSchema = z.object({
	projectId: z.string(),
	userEmail: z.string(),
	userRole: projectRoleSchema,
});
